import styled, { css } from "styled-components";

export const StyledMiddleRow = styled.div`
    ${p =>
        p.theme.sm.min(css`
            margin-top: 0;
        `)}
`;

export const BasicInfo = styled.div``;

export const PlanTitle = styled.h3`
    margin-top: 0;
    font-size: 32px;
    font-weight: 400;
    color: ${p => p.theme.c.black};
    margin-bottom: 18px;
    display: inline-block;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ${p =>
        p.theme.xs(css`
            font-size: 28px;
            margin-top: 12px;
            display: block;
        `)}
`;

export const TitleText = styled.span`
    margin-right: 12px;
    flex: 1;
    ${p =>
        p.theme.md.min(css`
            white-space: nowrap;
        `)}
    ${p =>
        p.theme.xs(css`
            display: block;
        `)}
    
    
    .EditTitle .i-edit {
        top: -5px;
    }

    .EditTitle,
    .EditDescription {
        opacity: 0;
        ${p =>
            p.theme.sm.max(css`
                opacity: 1;
            `)}
        transition: 200ms;
        .i-edit {
            margin: -12px 0 -14px;
            font-size: 36px;
            display: inline-block;
            overflow: hidden;
            color: ${p => p.theme.c.active};
            transition: 300ms;
            cursor: pointer;
            position: relative;
            &:hover {
                transform: scale(1.2);
            }
        }
    }

    &:hover {
        .EditTitle,
        .EditDescription {
            opacity: 1;
        }
    }
`;

export const PlanDescription = styled(TitleText)`
    font-size: 16px;
    margin-right: 0;
    color: ${p => p.theme.c.grey7};
    font-weight: 300;

    ${p =>
        p.theme.sm.max(css`
            margin-bottom: 24px;
        `)}
`;

export const DescriptionnText = styled.span`
    white-space: initial;
`;

export const Creator = styled.div`
    display: inline-block;
    font-size: 18px;

    > div {
        display: flex;
        align-items: center;
    }
`;

export const By = styled.span`
    font-size: 14px;
    font-weight: 300;
    font-variant: normal;
    margin-right: 8px;
    color: ${p => p.theme.c.grey7};
`;

export const Composer = styled.div`
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 3px;
`;

export const ComposerContainer = styled.div`
    font-size: 16px;
    display: flex;
    font-variant: none;
    font-weight: 300;
    color: ${p => p.theme.c.greyA};
    align-items: center;
`;

export const ComposerImg = styled.div`
    width: 26px;
    height: 26px;
    background-size: cover;
    border-radius: 13px;
    display: inline-block;
    margin-right: 8px;
`;

export const PlayButton = styled.button`
    &.button {
        border-radius: 22px;
        padding: 4px 9px;
        font-size: 16px;
    }
    [class^="i-"] {
        color: ${p => p.theme.c.whiteOnActive};
        font-size: 15px;
        display: inline-block;
        position: relative;
        top: 1px;
    }
`;

export const TrashButton = styled(PlayButton)`
    &.button {
        padding: 0;
        border-radius: 33px;
        width: 32px;
        height: 32px;
        margin-left: 8px;
        background-color: ${p => p.theme.c.info};
    }

    .i-trash {
        width: 24px;
        height: 24px;
        font-size: 24px;
    }
`;

export const AudioButtons = styled.span`
    float: right;
    margin-top: -12px;
    button {
        vertical-align: top;
    }
    ${p =>
        p.theme.sm.max(css`
            float: none;
            display: block;
        `)}
`;
